<template>
  <div id="twilio">
    <v-app>
      <v-stepper v-model="e6" vertical>
        <v-stepper-step step="1" v-bind:complete="e6 > 1">
          Input a Phone Number
          <small>Format (###) ###-####</small>
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-text-field
            label="Phone Number"
            v-model="phoneNumber"
            mask="(###) ###-####"
            hint="Input in the following format (###) ###-####"
            outline
          ></v-text-field>
          <v-btn color="primary" @click.native="e6 = 2">Continue</v-btn>
          <v-btn flat @click.native="e6 = 1">Cancel</v-btn>
        </v-stepper-content>
        <v-stepper-step step="2" v-bind:complete="e6 > 2">Include</v-stepper-step>
        <v-stepper-content step="2">
          <p>{{ this.phoneNumber }}</p>
          <v-switch
            v-model="swNone"
            label="None"
            color="red"
            hide-details
          ></v-switch>
          <v-switch
            v-model="swCarrier"
            label="Carrier"
            color="red"
            hide-details
          ></v-switch>
          <v-switch
            v-model="swCallerName"
            label="Caller Name"
            color="red darken-3"
            hide-details
          ></v-switch>
          <v-btn v-if="swNone" color="primary" @click="twilioLookup">Lookup</v-btn>
          <v-btn v-if="swCarrier" color="primary" @click="twilioLookupCarrier">Carrier Lookup</v-btn>
          <v-btn v-if="swCallerName" color="primary" @click="twilioLookupCallerName">Caller Name Lookup</v-btn>

          <v-btn flat @click.native="e6 = 1">Cancel</v-btn>
        </v-stepper-content>
      </v-stepper>
      <span v-if="this.twilioResponse.data != null">
        <v-card>
          <v-card-title><h4>{{ this.twilioResponse.config.params.PhoneNumber }}</h4></v-card-title>
          <v-divider></v-divider>
          <v-list dense>
            <v-list-tile>
              <v-list-tile-content>PhoneNumber:</v-list-tile-content>
              <v-list-tile-content class="align-end">{{ this.twilioResponse.config.params.PhoneNumber }}</v-list-tile-content>
            </v-list-tile>
            <span v-if="swCallerName">
            <v-list-tile>
              <v-list-tile-content>Caller Name:</v-list-tile-content>
              <v-list-tile-content class="align-end">{{ this.twilioResponse.data.caller_name.error_code }}</v-list-tile-content>
              <v-list-tile-content class="align-end">Caller Name: {{ this.twilioResponse.data.caller_name.caller_name }}</v-list-tile-content>
              <v-list-tile-content class="align-end">Caller Type: {{ this.twilioResponse.data.caller_name.caller_type }}</v-list-tile-content>
            </v-list-tile>
            </span>
            <span v-else></span>
            <span v-if="swCarrier">
            <v-list-tile>
              <v-list-tile-content>Carrier:</v-list-tile-content>
              <v-list-tile-content class="align-end">Country Code: {{ this.twilioResponse.data.carrier.mobile_country_code }}</v-list-tile-content>
              <v-list-tile-content class="align-end">Nework Code: {{ this.twilioResponse.data.carrier.mobile_network_code }}</v-list-tile-content>
              <v-list-tile-content class="align-end">{{ this.twilioResponse.data.carrier.name }}</v-list-tile-content>
              <v-list-tile-content class="align-end">{{ this.twilioResponse.data.carrier.type }}</v-list-tile-content>
            </v-list-tile>
            </span>
            <span v-else></span>
            <v-list-tile>
              <v-list-tile-content>Country Code:</v-list-tile-content>
              <v-list-tile-content class="align-end">{{ this.twilioResponse.data.country_code }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>National Format:</v-list-tile-content>
              <v-list-tile-content class="align-end">{{ this.twilioResponse.data.national_format }}</v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>URL:</v-list-tile-content>
              <v-list-tile-content class="align-end">{{ this.twilioResponse.data.url }}</v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
        <vue-json-pretty
          :path="'res'"
          :data="{ key: this.twilioResponse }"
          >
        </vue-json-pretty>
      </span>
      <span v-else>
      </span>
    </v-app>
  </div>
</template>

<script>
import axios from 'axios'
import VueJsonPretty from 'vue-json-pretty'

export default {
  name: 'twilio',
  components: {
    VueJsonPretty
  },
  data() {
    return {
      phoneNumber: null,
      e6: 1,
      swNone: false,
      swCarrier: false,
      swCallerName: false,
      twilioResponse: 's'
    }
  },
  created () {
  },
  methods: {
    twilioLookup() {
      axios.get('https://lookups.twilio.com/v1/PhoneNumbers/' + this.phoneNumber, {
        params: {
          PhoneNumber: this.phoneNumber,
        },
        auth: {
          username: 'AC51a6dae2b0791c3bba0d01e94d139259',
          password: '70678e1c70aeb39eab0bb3e2f49281de'
        }
      })
      .then(response => (
        this.twilioResponse = response,
        // caller_name
        // country_code
        // phone_number
        // national_
        console.log(response)
        ))
      .catch(function (error) {
        console.log(error);
      })
    },
    twilioLookupCarrier() {
      axios.get('https://lookups.twilio.com/v1/PhoneNumbers/' + this.phoneNumber + '?Type=carrier', {
        params: {
          PhoneNumber: this.phoneNumber,
        },
        auth: {
          username: 'AC51a6dae2b0791c3bba0d01e94d139259',
          password: '70678e1c70aeb39eab0bb3e2f49281de'
        }
      })
      .then(response => (
        this.twilioResponse = response,
        console.log(response)
        ))
      .catch(function (error) {
        console.log(error);
      })
    },
    twilioLookupCallerName() {
      axios.get('https://lookups.twilio.com/v1/PhoneNumbers/' + this.phoneNumber + '?Type=caller-name', {
        params: {
          PhoneNumber: this.phoneNumber,
        },
        auth: {
          username: 'AC51a6dae2b0791c3bba0d01e94d139259',
          password: '70678e1c70aeb39eab0bb3e2f49281de'
        }
      })
      .then(response => (
        this.twilioResponse = response,
        console.log(response)
        ))
      .catch(function (error) {
        console.log(error);
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Twilio.vue